import React from "react";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { External } from "../../Link";
import { makeStyles } from "@material-ui/core/styles";
import { Headline, Paragraph } from "./index";

const useStyles = makeStyles((theme) => ({
  link: {
    textDecoration: "underline",
    cursor: "pointer",
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.dark,
    },
  },
}));
const MoreOutbrain = () => {
  const classes = useStyles();
  return (
    <Box mt={4}>
      <Headline>Servicebeschreibung</Headline>
      <Paragraph>
        Dies ist ein Conversion-Marketing-Service. Dies bedeutet, dass
        verbesserte Targeting-Funktionen dabei helfen, personalisierte Werbung
        anzuzeigen und der Erfolg dieser Werbemaßahmen messbar wird.
      </Paragraph>
      <Headline>Verarbeitendes Unternehmen</Headline>
      <Paragraph>
        Outbrain Inc <br />
        39 W 13th Street, New York, NY 10011, USA{" "}
      </Paragraph>
      <Headline>Datenverarbeitungszwecke</Headline>
      <Paragraph>
        Diese Liste stellt die Zwecke der Datenerhebung und -verarbeitung dar.{" "}
        <br />- Werbung, Conversion-Tracking
      </Paragraph>
      <Headline>Verwendete Technologien</Headline>
      <Paragraph>
        Diese Liste enthält alle Technologien, mit denen dieser Dienst Daten
        sammelt. Typische Technologien sind Cookies und Pixel, die im Browser
        platziert werden. <br />- Cookies, Pixel
      </Paragraph>
      <Headline>Erhobene Daten</Headline>
      <Paragraph>
        Diese Liste enthält alle (persönlichen) Daten, die von oder durch die
        Nutzung dieses Dienstes gesammelt werden.
        <br />- IP-Adresse, User-Agent-Daten, Browser- und Gerätetyp
        (Desktop/Mobile, Marke, Modell, Betriebssystem und Systemversion),
        Anwendungsversion, Anwendungs-ID oder Paketname, Kennungen für
        Gerätewerbung, Seiten, besuchte Inhalte und Ereignisse, Datum und
        Uhrzeit des Besuchs, Allgemeiner Standort, Zeitzone des Geräts,
        Cookie-ID
      </Paragraph>
      <Headline>Rechtliche Grundlage</Headline>
      <Paragraph>
        Im Folgenden wird die erforderliche Rechtsgrundlage für die Verarbeitung
        von Daten genannt.
        <br />- Art. 6 (1) (a) GDPR
      </Paragraph>
      <Headline>Ort der Verarbeitung</Headline>
      <Paragraph>
        Dies ist der primäre Ort, an dem die gesammelten Daten verarbeitet
        werden. Sollten die Daten auch in anderen Ländern verarbeitet werden,
        werden Sie gesondert informiert. <br />- USA
      </Paragraph>
      <Headline>Aufbewahrungsdauer</Headline>
      <Paragraph>
        Die Aufbewahrungsfrist ist die Zeitspanne, in der die gesammelten Daten
        für die Verarbeitung gespeichert werden. Die Daten müssen gelöscht
        werden, sobald sie für die angegebenen Verarbeitungszwecke nicht mehr
        benötigt werden.
        <br />- Die Daten werden gelöscht, sobald sie nicht mehr für die
        Verarbeitungszwecke benötigt werden.
      </Paragraph>
      <Paragraph>
        <External
          target="_blank"
          className={classes.link}
          href="https://www.outbrain.com/privacy/de/"
        >
          Klicken Sie hier
        </External>
        , um die Datenschutzbestimmungen des Datenverarbeiters zu lesen. <br />
        <External
          target="_blank"
          className={classes.link}
          href="https://www.outbrain.com/privacy/cookies/"
        >
          Klicken Sie hier
        </External>
        , um die Cookie-Richtlinie des Datenverarbeiters zu lesen. <br />
        <External
          target="_blank"
          className={classes.link}
          href="https://my.outbrain.com/recommendations-settings/home"
        >
          Klicken Sie hier
        </External>
        , um das Einverständnis für verhaltensbezogene Anzeigen zu widerrufen
        und/oder die Weiterleitung Ihrer persönlichen Informationen an
        Drittanbieter durch das verarbeitende Unternehmen zu unterbinden.
      </Paragraph>
    </Box>
  );
};

export default MoreOutbrain;
